import { t as translate } from 'i18n';
/**
 * A clarifying form (the model's `ask_user`) answered in the UI goes back as
 * one plain user message, the same channel as a typed question:
 * «Период: последний месяц; Разбивка: по источникам».
 */

/** Sent when the user skips the form instead of answering it. */
export const SKIP_FORM_MESSAGE = () => translate('assistant.composeFormChooseAReasonableOptionWithoutAskingMe');

/** The question as a label: trailing «?», «:» and spaces dropped. */
function label(text) {
  return String(text || '').trim().replace(/[\s?:]+$/u, '');
}

/**
 * @param {Array<{id: string, text: string, options: string[], multiple: boolean}>} questions
 * @param {{[id: string]: string[]}} answers  chosen options per question id
 * @returns {string} '' when nothing was chosen
 */
export function composeFormMessage(questions, answers) {
  if (!Array.isArray(questions)) return '';
  const parts = [];
  for (const question of questions) {
    const options = Array.isArray(question?.options) ? question.options : [];
    // Keep the form's own option order, and only options it actually offered.
    const chosen = options.filter((option) => (answers?.[question.id] || []).includes(option));
    if (chosen.length === 0) continue;
    const name = label(question.text);
    const value = chosen.join(', ');
    parts.push(name ? `${name}: ${value}` : value);
  }
  return parts.join('; ');
}

/** Toggle `option` for one question: radio-like unless `multiple`. */
export function toggleAnswer(answers, question, option) {
  const current = answers[question.id] || [];
  let next;
  if (current.includes(option)) {
    next = current.filter((o) => o !== option);
  } else {
    next = question.multiple ? [...current, option] : [option];
  }
  return { ...answers, [question.id]: next };
}
